// Import Firebase modules
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

// Firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  clientId: process.env.REACT_APP_APPLE_CLIENTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID,
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
auth.useDeviceLanguage(); // Set Firebase auth language

// 💥 Only initialize messaging if supported
let messaging = null;
const setupMessaging = async () => {
  const supported = await isSupported(); 
  if (supported) {
    messaging = getMessaging(firebaseApp);
  } 
};
setupMessaging();

// ✅ Get Notification Token
export const getTokenNotification = async () => {
  try {
    const supported = await isSupported();
    if (!supported) {
      console.warn("Push notifications are not supported on this browser.");
      return null;
    }

    const currentToken = await getToken(getMessaging(firebaseApp), {
      vapidKey: process.env.REACT_APP_API_FIREBASE_VAPID_KEY,
    });

    if (currentToken) {
      return currentToken;
    } else {
      console.warn("No registration token available.");
      return null;
    }
  } catch (err) {
    // console.error("Error getting token:", err);
  }
};

// ✅ reCAPTCHA Setup (only once)
// export const setupRecaptcha = async () => { 
//   if (!window.recaptchaVerifier) {
//     try {
//       window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
//         size: "invisible",
//         callback: async () => console.log("reCAPTCHA verified"),
//         // "expired-callback": async () => console.warn("reCAPTCHA expired. Please try again."),
//       });
//       return window.recaptchaVerifier;
//     } catch (error) {
//       console.error("Error setting up reCAPTCHA:", error);
//       throw error;
//     }
//   }
//   return window.recaptchaVerifier;
// };

// ✅ Send OTP Function
// export const sendOTP = async (phoneNumber, recaptchaVerifier) => {
//   // console.log("recaptchaVerifier", recaptchaVerifier);
//   try {
//     const confirmation = await signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifier);
//     return confirmation; // Return for later verification
//   } catch (error) {
//     console.error("Error sending OTP:", error.message);
//     throw error;
//   }
// };

// // ✅ Verify OTP Function
// export const verifyOTP = async (otp, confirmationResult, dispatch) => {
//   try {
//     const result = await confirmationResult.confirm(otp);
//     await dispatch({ type: "OTP_VERIFIED", payload: result.user });
//     console.log("OTP Verified:", result.user);
//   } catch (error) {
//     console.error("Invalid OTP:", error.message);
//     throw error;
//   }
// };



// ✅ Social Logout
export const socialLogout = async () => {
  try {
    const user = auth.currentUser;
    if (user) {
      await auth.signOut();
    }
  } catch (error) {
    console.error("Firebase logout error:", error);
  }
};

export { auth, messaging };
